import * as THREE from 'three'
import Model from './Model'
import Variant from './Variant'

class Part extends THREE.Group {
  uuid: string
  component: string
  model: Model
  variants: THREE.Group

  constructor({
    uuid,
    model,
    datatype,
    islands,
    structure,
  }: {
    uuid: string
    model: Model
    datatype: string
    islands: any
    structure: any
  }) {
    super()
    this.uuid = uuid
    this.component = 'part'
    this.model = model
    this.variants = new THREE.Group()

    if (datatype !== 'part') {
      console.error(
        `There is an issues with the data provided` +
          `@model:${model.uuid} @part:${uuid}`
      )
    }

    let count = 0
    for (let variantKey in structure) {
      const variant_uuid = variantKey
      const variant_structure = structure[variantKey]
      const parmObject = {
        uuid: variant_uuid,
        model: model,
        part: this,
        datatype: 'variant',
        islands,
        structure: variant_structure,
      }
      const variant = new Variant({ ...parmObject })
      if (count !== 0) {
        variant.visible = false
      }

      this.variants.add(variant)

      count++
    }
    this.add(this.variants)
  }
}

export default Part
